<script setup lang="ts">
import type { TabsContentProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { TabsContent, useForwardProps } from 'reka-ui';

const props = defineProps<TabsContentProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <TabsContent
    v-bind="forwarded"
    :class="cn('flex flex-col gap-3 focus-visible:outline-none data-[state=inactive]:hidden', props.class)"
  >
    <slot />
  </TabsContent>
</template>
